export default "__VITE_ASSET__DJabl57Y__"